'use strict';

/**
 * @classname BtnShowMore
 * @classdesc もっと見る
 */
export default class BtnShowMore {
	/**
	 * @constructor
	 * @param {jQuery} $e - [data-toggle=BtnShowMore]
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof BtnShowMore
	 * @return undefined
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		this._$e.closest('.section').find('.list__item').show();
		this._$e.closest('.block--btn-box').remove();
		this._$e.remove();
	};


	/**
	 * モーダルを閉じる
	 *
	 * @memberof BtnShowMore
	 * @return undefined
	 */
	BtnShowMoreClose() {
		console.log(`${this.constructor.name}.BtnShowMoreClose`);
		$('.BtnShowMore-bg').remove();
		this._$target.removeClass('show');
	};
};
